import { useCallback, useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, dateTime, formatError, money } from "../../lib/api";
import { DatePicker } from "./DatePicker";
import { StatusPill } from "./PaymentsDesk";

const STATUSES = ["created", "paid", "expired", "cancelled", "failed", "requested", "queued", "pending", "processing", "processed", "reversed", "rejected"];

export const DeskLedger = () => {
  const [q, setQ] = useState({ type: "", status: "", date_from: "", date_to: "" });
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/desk/ledger", { params: q }).then((r) => setRows(r.data)).catch((e) => toast.error(formatError(e))), [q]);
  useEffect(() => { load(); }, [load]);
  const set = (k) => (e) => setQ({ ...q, [k]: e.target.value });
  const download = async () => {
    try {
      const r = await api.get("/admin/desk/ledger.csv", { params: q, responseType: "blob" });
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: "availity-payments-desk.csv" });
      a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div>
      <div className="desk-filters" data-testid="ledger-filters">
        <select className="search" data-testid="ledger-type-filter" value={q.type} onChange={set("type")}><option value="">All types</option><option value="payin">Pay-ins</option><option value="payout">Payouts</option></select>
        <select className="search" data-testid="ledger-status-filter" value={q.status} onChange={set("status")}><option value="">All statuses</option>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
        <DatePicker testId="ledger-from-filter" placeholder="From date" value={q.date_from} onChange={(v) => setQ({ ...q, date_from: v })} />
        <DatePicker testId="ledger-to-filter" placeholder="To date" value={q.date_to} onChange={(v) => setQ({ ...q, date_to: v })} />
        <button className="button secondary" data-testid="ledger-csv-button" onClick={download}><Download size={16} /> CSV</button>
      </div>
      <div className="table-wrap"><table className="admin-table" data-testid="ledger-table"><thead><tr><th>Date</th><th>Type</th><th>Person</th><th>Purpose</th><th>Amount</th><th>Status</th><th>Reference</th><th>By</th></tr></thead>
        <tbody>{(rows || []).map((r) => (
          <tr key={r.id} data-testid={`ledger-row-${r.id}`}><td>{dateTime(r.date)}</td><td><span className={`pill ${r.type === "payin" ? "published" : "draft"}`}>{r.type === "payin" ? "pay-in" : "payout"}</span></td>
            <td><b>{r.name}</b><small>{r.contact}</small></td><td>{r.purpose}</td><td><b>{r.type === "payout" ? "−" : "+"}{money(r.amount_minor)}</b></td>
            <td><StatusPill status={r.status} /></td><td><code>{r.reference || "—"}</code></td><td><small>{r.created_by}</small></td></tr>))}</tbody></table>
        {rows && !rows.length && <div className="empty-state" data-testid="ledger-empty-state">No entries match these filters.</div>}</div>
    </div>
  );
};
